import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    passwordReset: false,
    email: null,
    otp: null,
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        RESET_PASSWORD_INITIATE: (state, action) => {
            state.loading = false;
            state.passwordReset = true;
            state.email = action.payload;
            state.otp = null;
        },
        RESET_PASSWORD_OTP_UPDATE: (state, action) => {
            state.loading = false;
            state.passwordReset = true;
            // eslint-disable-next-line
            state.email = state.email;
            state.otp = action.payload;
        },
        RESET_PASSWORD_SUCCESS: (state) => {
            state.loading = false;
            state.passwordReset = false;
            state.email = null;
            state.otp = null;
        },
    },
})

// Action creators are generated for each case reducer function
export const { RESET_PASSWORD_INITIATE, RESET_PASSWORD_OTP_UPDATE, RESET_PASSWORD_SUCCESS } = authSlice.actions

export default authSlice.reducer;